import React from 'react'

function Newsletter() {
  return (
    <div>Newsletter</div>
  )
}

export default Newsletter